<template>
  <div class="esp_page_footer">
    <div>
      <slot name="left"></slot>
    </div>
    <div>
      <slot></slot>
    </div>
    <div>
      <slot name="right"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "EspPageFooter",
  data() {
    return {}
  }
}
</script>

<style scoped lang="less">
.esp_page_footer {
  display: -webkit-flex;
  display: flex;
  margin-top: 5px;

  & > div {
    -webkit-box-flex: 1;
    flex: 1;

    &:last-of-type {
      text-align: right;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layout/EspPageFooter.vue